import { AprobadoComponent } from 'src/app/pago/containers/estado-pago/aprobado/aprobado.component';
import { PendienteComponent } from 'src/app/pago/containers/estado-pago/pendiente/pendiente.component';
import { RechazadoComponent } from 'src/app/pago/containers/estado-pago/rechazado/rechazado.component';

export const ESTADO_PAGO_COMPONENTS: ComponentList = {
  APROBADO: AprobadoComponent,
  PENDIENTE: PendienteComponent,
  RECHAZADO: RechazadoComponent,
};

interface ComponentList {
  APROBADO: typeof AprobadoComponent;
  PENDIENTE: typeof PendienteComponent;
  RECHAZADO: typeof RechazadoComponent;
}
